export const TEXTS = {
  MODAL_TITLE: 'Оплатите и заиграет музыка',
  MODAL_DESCRIPTION: 'Устройство привязано к адресу. Музыка зазвучит в вашем плеере после оплаты:',
  MODAL_BUTTON_SUBMIT: 'Перейти к оплате',
};
